const GrmMediaPipeObject = {
    data: {},
    add (name, clazz) {
        this.data[name] = clazz;
    },
    get (name) {
        return this.data[name];
    }
}

class GrmMediaPipeInterface {
    options={};
    constructor(options) {
        Object.assign(this.options, options);
    }
    async init () {
    }
    async render ({image, canvas, ctx}) {
    }
    setOptions (options) {
        if(options !== this.options){
            Object.assign(this.options, options);
        }
    }
}

export {
    GrmMediaPipeObject,
    GrmMediaPipeInterface
}